"use strict";var e=require("styled-components"),t=require("../../core/styles/variablesToBreakpoints/index.js");const i=e.css`
    display: flex;
    flex-direction: column;
    gap: ${({theme:e})=>e.spacing.medium};
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    width: ${({fullwidth:e})=>e?"100%":"auto"};

    ${({direction:e,gap:i,alignItems:n,justifyContent:s,flexWrap:r,theme:a})=>t({breakpoints:a.breakpoints,variables:{"flex-direction":e,gap:i,"align-items":n,"justify-content":s,"flex-wrap":r}})}
`;module.exports=i;
//# sourceMappingURL=styles.js.map
